<!--
	This is the user profile page, it uses the dashboard layout in:
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <!-- Header Background (brand blue gradient) -->
    <div class="profile-nav-bg profile-nav-bg--brand"></div>
    <!-- / Header Background -->

    <!-- User Profile Card -->
    <a-card
      :bordered="false"
      class="card-profile-head"
      :bodyStyle="{ padding: 0 }"
    >
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="12" class="col-info">
            <a-avatar :size="74" shape="square" class="profile-avatar">
              {{ avatarInitial }}
            </a-avatar>
            <div class="avatar-info">
              <h4 class="font-semibold m-0">系统管理员</h4>
              <p>超级用户</p>
            </div>
          </a-col>
        </a-row>
      </template>
    </a-card>
    <!-- User Profile Card -->

    <a-row type="flex" :gutter="24">
      <a-col :span="24" :md="24" class="mb-24">
        <a-alert
          message="到期时间"
          :description="'您的账号到期时间为:' + expiryDate"
          type="info"
          show-icon
        />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {getUser} from '@/api/index'

export default {
  data() {
    return {
      expiryDate: "",
    };
  },
  computed: {
    // 品牌占位头像：取角色名首字，避免使用库存陌生人照片
    avatarInitial() {
      return "管";
    },
  },
  mounted(){
    getUser().then((res)=>{
      this.expiryDate = res.data.expiry_date
    })
  }
};
</script>

<style lang="scss" scoped>
// 品牌蓝渐变头部（参考客户端 hero token：#1e40af -> #3b82f6）
.profile-nav-bg--brand {
  background-image: linear-gradient(135deg, #1e40af 0%, #3b82f6 100%);
}

// 品牌占位头像
::v-deep .profile-avatar {
  background: linear-gradient(135deg, #1d4ed8 0%, #3b82f6 100%);
  color: #fff;
  font-size: 30px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
